export const SITE = {
  name: "OddStack",
  title: "OddStack — Digital Studio",
  description: "Crafting digital experiences that defy convention. We don't follow trends — we architect the future of interactive design.",
  url: "https://theoddstack.com",
  ogImage: "https://theoddstack.com/images/og/oddstack-og.png",
  socials: [
    { label: "Instagram", url: "https://www.instagram.com/borstphoto/" },
    { label: "TikTok", url: "https://www.tiktok.com/@borstphoto" },
    { label: "Facebook", url: "https://www.facebook.com/borstphoto" },
    { label: "LinkedIn", url: "https://www.linkedin.com/in/jason-borst-300067a2/" },
    { label: "GitHub", url: "https://github.com/CartKeeper" },
    { label: "Photography", url: "https://borstphoto.com" },
  ],
} as const;
